module.exports = __webpack_public_path__ + "static/media/icon-coaches.9a963e52.svg";